var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 224,
    viewBox: "0 0 240 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.387 79.9819C219.068 97.2983 220.277 118.707 211.463 135.562C203.246 151.275 182.072 152.972 167.761 163.409C155.345 172.464 148.667 190.961 133.424 192.476C118.175 193.991 108.645 176.065 94.3191 170.707C74.8031 163.409 48.3111 171.943 35.1889 155.738C22.1622 139.651 23.4679 113.477 32.9895 94.9701C42.0124 77.4322 66.6938 77.0672 82.0294 64.6932C96.3532 53.1356 101.204 29.8376 119.05 25.5298C137.198 21.1489 154.518 33.8681 170.553 43.3241C186.699 52.8457 203.77 62.8077 211.387 79.9819Z",
    fill: "#37447F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.444 105.635C159.588 105.633 160.514 104.706 160.511 103.565C160.509 102.424 159.58 101.501 158.436 101.503C157.292 101.506 156.367 102.432 156.369 103.573C156.371 104.714 157.3 105.637 158.444 105.635Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.886 124.494C150.969 124.714 150.984 124.953 150.931 125.181C150.877 125.409 150.757 125.617 150.585 125.777C150.414 125.937 150.198 126.043 149.966 126.081C149.735 126.119 149.497 126.087 149.283 125.99C149.069 125.893 148.889 125.735 148.765 125.536C148.641 125.336 148.579 125.105 148.587 124.871C148.595 124.636 148.672 124.41 148.81 124.219C148.947 124.029 149.137 123.883 149.357 123.801C149.503 123.746 149.659 123.72 149.815 123.726C149.97 123.731 150.124 123.767 150.266 123.831C150.408 123.896 150.536 123.987 150.642 124.101C150.749 124.215 150.832 124.348 150.886 124.494Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.653 127.775C107.735 127.995 107.751 128.234 107.697 128.462C107.644 128.691 107.523 128.898 107.352 129.058C107.18 129.218 106.965 129.324 106.733 129.362C106.501 129.4 106.263 129.368 106.049 129.271C105.835 129.174 105.655 129.016 105.531 128.817C105.407 128.617 105.346 128.386 105.353 128.152C105.361 127.917 105.439 127.691 105.576 127.5C105.713 127.31 105.904 127.164 106.124 127.082C106.27 127.027 106.425 127.002 106.581 127.007C106.737 127.012 106.89 127.048 107.032 127.112C107.174 127.177 107.302 127.268 107.409 127.382C107.515 127.496 107.598 127.63 107.653 127.775Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7 80.1336C153.844 80.5164 153.871 80.9332 153.778 81.3312C153.684 81.7293 153.475 82.0907 153.175 82.3699C152.876 82.649 152.5 82.8333 152.096 82.8995C151.692 82.9656 151.277 82.9107 150.904 82.7415C150.531 82.5724 150.217 82.2967 150.001 81.9493C149.785 81.6018 149.677 81.1983 149.691 80.7897C149.705 80.3811 149.84 79.9858 150.079 79.6538C150.318 79.3218 150.65 79.0679 151.034 78.9244C151.288 78.8288 151.559 78.7844 151.831 78.7935C152.103 78.8025 152.371 78.865 152.618 78.9774C152.866 79.0897 153.089 79.2496 153.275 79.448C153.46 79.6464 153.605 79.8794 153.7 80.1336Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.99 62.6602C107.134 62.6602 108.061 61.7353 108.061 60.5945C108.061 59.4536 107.134 58.5287 105.99 58.5287C104.846 58.5287 103.918 59.4536 103.918 60.5945C103.918 61.7353 104.846 62.6602 105.99 62.6602Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2694 84.3177C84.9338 84.3162 85.4714 83.7777 85.4701 83.115C85.4688 82.4523 84.9291 81.9163 84.2646 81.9178C83.6002 81.9194 83.0626 82.4578 83.0639 83.1206C83.0652 83.7833 83.6049 84.3193 84.2694 84.3177Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.049 59.1151C125.119 59.3008 125.132 59.5031 125.086 59.6962C125.041 59.8894 124.939 60.0648 124.794 60.2003C124.649 60.3357 124.467 60.4252 124.27 60.4573C124.074 60.4894 123.873 60.4627 123.692 60.3807C123.511 60.2986 123.358 60.1648 123.254 59.9962C123.149 59.8276 123.096 59.6318 123.103 59.4335C123.11 59.2352 123.175 59.0434 123.291 58.8823C123.407 58.7211 123.569 58.5979 123.755 58.5282C123.878 58.4819 124.01 58.4603 124.142 58.4647C124.274 58.4691 124.403 58.4994 124.524 58.5539C124.644 58.6084 124.752 58.686 124.842 58.7823C124.932 58.8786 125.002 58.9917 125.049 59.1151Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2839 115.963C90.4278 115.96 91.3531 115.033 91.3505 113.892C91.3479 112.751 90.4185 111.829 89.2746 111.831C88.1307 111.834 87.2055 112.761 87.208 113.902C87.2106 115.043 88.14 115.965 89.2839 115.963Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.752 121.491C120.582 121.864 120.306 122.178 119.958 122.393C119.61 122.609 119.206 122.717 118.796 122.703C118.387 122.689 117.991 122.555 117.658 122.316C117.325 122.078 117.071 121.746 116.927 121.363C116.783 120.98 116.756 120.563 116.85 120.165C116.943 119.767 117.153 119.406 117.452 119.127C117.752 118.848 118.127 118.663 118.532 118.597C118.936 118.531 119.351 118.587 119.724 118.756C120.223 118.983 120.612 119.399 120.805 119.912C120.997 120.424 120.978 120.993 120.752 121.491Z",
    fill: "url(#paint8_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6875 130.106C98.5904 130.319 98.432 130.499 98.2324 130.623C98.0327 130.746 97.8008 130.808 97.5659 130.8C97.3311 130.793 97.1038 130.715 96.913 130.579C96.7221 130.442 96.5762 130.252 96.4936 130.032C96.4111 129.812 96.3957 129.573 96.4493 129.345C96.503 129.117 96.6233 128.909 96.795 128.749C96.9668 128.589 97.1822 128.484 97.4141 128.446C97.646 128.408 97.884 128.439 98.0979 128.537C98.3843 128.667 98.6073 128.905 98.7179 129.199C98.8284 129.493 98.8175 129.819 98.6875 130.106Z",
    fill: "url(#paint9_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.315 99.8685C132.317 98.7277 131.39 97.8019 130.246 97.8007C129.102 97.7996 128.174 98.7235 128.173 99.8644C128.172 101.005 129.098 101.931 130.242 101.932C131.386 101.933 132.314 101.009 132.315 99.8685Z",
    fill: "url(#paint10_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.319 53.2686C114.323 52.1277 113.4 51.1991 112.256 51.1946C111.112 51.19 110.181 52.1112 110.176 53.252C110.172 54.3929 111.095 55.3215 112.239 55.326C113.383 55.3306 114.314 54.4094 114.319 53.2686Z",
    fill: "url(#paint11_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0127 54.3636C81.9144 54.5798 81.754 54.7621 81.5518 54.8874C81.3496 55.0126 81.1147 55.0752 80.8768 55.0672C80.639 55.0592 80.4089 54.981 80.2156 54.8424C80.0223 54.7039 79.8745 54.5112 79.7909 54.2888C79.7074 54.0665 79.6918 53.8243 79.7461 53.5931C79.8005 53.3619 79.9223 53.1519 80.0963 52.9898C80.2702 52.8277 80.4884 52.7207 80.7233 52.6824C80.9581 52.6441 81.1991 52.6762 81.4157 52.7745C81.7058 52.9065 81.9316 53.1479 82.0435 53.4458C82.1555 53.7437 82.1444 54.0738 82.0127 54.3636Z",
    fill: "url(#paint12_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.772 65.6541C126.69 65.8349 126.556 65.9872 126.387 66.0919C126.218 66.1965 126.022 66.2489 125.823 66.2422C125.624 66.2355 125.432 66.1702 125.27 66.0545C125.109 65.9387 124.985 65.7778 124.916 65.592C124.846 65.4062 124.833 65.2039 124.878 65.0107C124.923 64.8175 125.025 64.6421 125.171 64.5066C125.316 64.3712 125.498 64.2818 125.694 64.2497C125.891 64.2177 126.092 64.2445 126.273 64.3267C126.515 64.4369 126.704 64.6385 126.798 64.8874C126.891 65.1363 126.882 65.412 126.772 65.6541Z",
    fill: "url(#paint13_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.256 110.83C152.784 109.086 151.955 106.582 151.955 106.582C151.955 106.582 150.064 99.0874 149.242 96.0963C148.828 94.5877 148.8 93.1852 149.155 92.088L154.256 110.83Z",
    fill: "#FDC8A8"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.388 67.6469C137.114 67.5084 136.092 68.7936 135.936 69.4908C135.779 70.188 138.389 69.6242 139.511 69.8793C140.635 70.1328 141.129 69.3362 141.286 68.6385C141.443 67.9387 140.16 67.8414 138.388 67.6469Z",
    fill: "#FDC8A8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.955 106.582C151.955 106.582 152.685 109.24 154.452 111.299L149.296 91.7148C148.798 92.8575 148.779 94.4111 149.242 96.0964C150.064 99.0877 151.955 106.582 151.955 106.582Z",
    fill: "#FDC8A8"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.706 153.089C113.724 156.956 117.561 159.334 121.232 158.372L156.572 149.116C160.242 148.155 162.413 144.204 161.395 140.337L141.832 66.0479C140.814 62.1805 136.978 59.8033 133.306 60.7646L97.9666 70.0205C94.2963 70.9819 92.1255 74.9326 93.1438 78.7998L112.706 153.089Z",
    fill: "#565656"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.457 150.841C114.423 154.509 118.062 156.764 121.543 155.852L155.058 147.074C158.539 146.162 160.597 142.415 159.631 138.748L141.08 68.296C140.114 64.6284 136.477 62.3739 132.995 63.2862L99.4799 72.0641C95.9989 72.9758 93.9405 76.7224 94.9062 80.39L113.457 150.841Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.457 150.841C114.423 154.509 118.062 156.764 121.543 155.852L155.058 147.074C158.539 146.162 160.597 142.415 159.631 138.748L141.08 68.296C140.114 64.6284 136.477 62.3739 132.995 63.2862L99.4799 72.0641C95.9989 72.9758 93.9405 76.7224 94.9062 80.39L113.457 150.841Z",
    fill: "url(#paint14_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.675 124.815L136.691 124.81L136.688 124.797L136.67 124.802C136.672 124.806 136.674 124.811 136.675 124.815Z",
    fill: "#B5CEE5"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.806 125.121L137.822 125.116L137.819 125.104L137.802 125.109C137.803 125.113 137.805 125.117 137.806 125.121Z",
    fill: "#74ECF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.823 125.116L137.807 125.121C137.806 125.117 137.804 125.113 137.802 125.109L137.82 125.104L137.823 125.116Z",
    fill: "#A5C6E5"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M138.594 118.775L138.606 118.771L138.604 118.762L138.59 118.766C138.591 118.769 138.593 118.772 138.594 118.775Z",
    fill: "#B5CEE5"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.467 119.011L139.479 119.007L139.477 118.998L139.463 119.002C139.464 119.005 139.466 119.009 139.467 119.011Z",
    fill: "#74ECF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139.481 119.007L139.468 119.011C139.467 119.008 139.466 119.005 139.465 119.002L139.479 118.998L139.481 119.007Z",
    fill: "#A5C6E5"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M136.172 126.26L136.189 126.255L136.185 126.243L136.167 126.248C136.169 126.252 136.17 126.256 136.172 126.26Z",
    fill: "#B5CEE5"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.35 126.58L137.367 126.575L137.363 126.562L137.345 126.567C137.346 126.572 137.348 126.576 137.35 126.58Z",
    fill: "#74ECF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.368 126.575L137.351 126.58C137.349 126.576 137.347 126.571 137.346 126.568L137.364 126.562L137.368 126.575Z",
    fill: "#A5C6E5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M159.591 136.278L160.241 138.614C161.264 142.286 159.249 146.08 155.764 147.045L153.002 147.811C155.199 143.967 157.396 140.123 159.591 136.278Z",
    fill: "white"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M145.546 84.5263L141.262 68.2573C140.291 64.5717 136.635 62.306 133.137 63.2223L116.497 67.5803C126.162 73.2601 135.845 78.9088 145.546 84.5263Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M148.524 104.665L151.27 106.264L150.34 102.735C133.909 93.2828 117.532 83.7397 101.208 74.1055C100.371 73.6151 99.6537 72.9463 99.1065 72.1469C97.9195 72.537 96.8751 73.2697 96.1055 74.2524C96.398 74.3667 96.6812 74.5033 96.9528 74.6609L148.009 104.399C148.185 104.48 148.357 104.568 148.524 104.665Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M132.799 153.779L110.885 141.015L109.912 137.422C118.674 142.591 127.453 147.734 136.247 152.85L132.799 153.779Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.275 104.069L112.569 111.5C111.168 111.889 109.659 110.69 109.216 108.834L108.174 104.474C107.731 102.619 108.515 100.783 109.916 100.393L140.991 91.7585C142.392 91.3692 143.901 92.5689 144.344 94.4244L145.386 98.7841C145.829 100.64 145.046 102.476 143.645 102.866L142.592 103.218L139.275 104.069Z",
    stroke: "#CBE6FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.03 101.829L116.538 101.693C116.609 101.674 116.678 101.662 116.744 101.658C116.811 101.655 116.872 101.662 116.927 101.682C116.983 101.7 117.032 101.733 117.073 101.78C117.116 101.825 117.148 101.888 117.169 101.969C117.191 102.049 117.196 102.12 117.185 102.181C117.173 102.242 117.15 102.294 117.113 102.338C117.077 102.383 117.029 102.42 116.971 102.451C116.913 102.48 116.848 102.504 116.776 102.524L116.555 102.583L116.698 103.116L116.397 103.196L116.03 101.829ZM116.487 102.328L116.688 102.274C116.715 102.267 116.74 102.257 116.763 102.246C116.788 102.234 116.808 102.219 116.824 102.202C116.841 102.184 116.853 102.163 116.859 102.139C116.866 102.114 116.865 102.085 116.856 102.053C116.847 102.018 116.831 101.993 116.809 101.977C116.788 101.959 116.763 101.948 116.734 101.943C116.706 101.938 116.677 101.938 116.645 101.944C116.613 101.948 116.583 101.954 116.555 101.962L116.4 102.003L116.487 102.328ZM117.475 101.343L117.65 101.992L117.653 101.991C117.655 101.971 117.661 101.951 117.672 101.928C117.682 101.906 117.697 101.885 117.715 101.865C117.733 101.845 117.756 101.827 117.783 101.81C117.81 101.793 117.841 101.78 117.876 101.77C117.949 101.751 118.012 101.747 118.063 101.758C118.114 101.768 118.157 101.789 118.192 101.823C118.229 101.856 118.259 101.898 118.282 101.95C118.306 102.001 118.326 102.059 118.343 102.122L118.482 102.639L118.192 102.717L118.068 102.257C118.061 102.23 118.052 102.203 118.042 102.175C118.033 102.146 118.02 102.12 118.003 102.099C117.988 102.077 117.967 102.061 117.943 102.051C117.919 102.04 117.889 102.04 117.851 102.05C117.814 102.06 117.786 102.075 117.766 102.096C117.747 102.115 117.733 102.138 117.727 102.164C117.721 102.189 117.72 102.216 117.724 102.246C117.727 102.275 117.733 102.305 117.742 102.336L117.867 102.804L117.577 102.881L117.186 101.421L117.475 101.343ZM118.526 102.125C118.506 102.05 118.502 101.979 118.512 101.911C118.523 101.843 118.546 101.782 118.581 101.727C118.617 101.67 118.663 101.622 118.72 101.582C118.778 101.542 118.844 101.512 118.916 101.493C118.988 101.473 119.059 101.467 119.128 101.473C119.199 101.479 119.263 101.498 119.321 101.529C119.38 101.559 119.431 101.601 119.475 101.654C119.518 101.707 119.55 101.771 119.57 101.846C119.59 101.921 119.594 101.992 119.583 102.06C119.573 102.127 119.549 102.189 119.513 102.246C119.478 102.301 119.432 102.348 119.374 102.389C119.317 102.429 119.252 102.459 119.18 102.478C119.108 102.497 119.036 102.504 118.966 102.498C118.896 102.491 118.832 102.473 118.773 102.444C118.715 102.412 118.664 102.37 118.621 102.317C118.578 102.263 118.546 102.199 118.526 102.125ZM118.816 102.047C118.835 102.118 118.87 102.17 118.922 102.203C118.975 102.236 119.038 102.242 119.112 102.223C119.185 102.203 119.236 102.166 119.264 102.112C119.293 102.057 119.299 101.994 119.28 101.923C119.261 101.852 119.225 101.801 119.172 101.768C119.12 101.735 119.058 101.728 118.984 101.748C118.911 101.767 118.859 101.804 118.83 101.859C118.802 101.914 118.797 101.976 118.816 102.047ZM119.614 101.331L119.893 101.257L119.927 101.384L119.931 101.383C119.935 101.363 119.943 101.341 119.955 101.319C119.967 101.296 119.982 101.275 120.002 101.254C120.021 101.234 120.045 101.215 120.072 101.198C120.099 101.181 120.13 101.168 120.165 101.159C120.238 101.139 120.3 101.135 120.352 101.146C120.403 101.156 120.446 101.178 120.481 101.211C120.517 101.244 120.547 101.287 120.571 101.338C120.595 101.39 120.615 101.447 120.632 101.51L120.77 102.028L120.481 102.106L120.357 101.646C120.35 101.619 120.341 101.591 120.331 101.564C120.322 101.535 120.309 101.509 120.292 101.487C120.276 101.465 120.256 101.449 120.232 101.439C120.208 101.429 120.178 101.429 120.14 101.439C120.103 101.449 120.075 101.464 120.055 101.484C120.035 101.503 120.022 101.526 120.016 101.553C120.01 101.578 120.009 101.605 120.013 101.634C120.016 101.664 120.022 101.694 120.031 101.725L120.156 102.192L119.866 102.27L119.614 101.331ZM121.821 101.574C121.791 101.645 121.744 101.707 121.682 101.758C121.62 101.809 121.551 101.845 121.475 101.865C121.403 101.884 121.331 101.891 121.261 101.885C121.191 101.879 121.127 101.861 121.068 101.831C121.01 101.799 120.959 101.757 120.916 101.704C120.873 101.65 120.841 101.586 120.821 101.512C120.801 101.437 120.796 101.366 120.807 101.298C120.818 101.23 120.841 101.169 120.876 101.114C120.912 101.058 120.958 101.009 121.015 100.969C121.073 100.929 121.138 100.899 121.21 100.88C121.277 100.862 121.341 100.857 121.401 100.866C121.463 100.874 121.518 100.896 121.568 100.929C121.618 100.962 121.661 101.005 121.698 101.06C121.735 101.115 121.763 101.18 121.783 101.255L121.807 101.346L121.135 101.525C121.161 101.577 121.199 101.615 121.246 101.638C121.293 101.66 121.345 101.663 121.402 101.648C121.45 101.636 121.487 101.615 121.514 101.585C121.541 101.555 121.563 101.519 121.578 101.479L121.821 101.574ZM121.465 101.226C121.453 101.177 121.426 101.139 121.383 101.113C121.34 101.087 121.292 101.082 121.239 101.096C121.207 101.104 121.18 101.117 121.158 101.134C121.137 101.151 121.119 101.17 121.106 101.191C121.093 101.211 121.084 101.234 121.08 101.258C121.077 101.281 121.077 101.305 121.082 101.328L121.465 101.226ZM122.327 100.147L122.737 100.037L123.573 100.833L123.577 100.832L123.322 99.8811L123.624 99.8006L123.99 101.168L123.596 101.274L122.738 100.459L122.734 100.46L122.995 101.434L122.694 101.515L122.327 100.147ZM125.137 100.862L124.859 100.936L124.825 100.809L124.821 100.81C124.815 100.831 124.806 100.852 124.795 100.875C124.784 100.897 124.769 100.918 124.75 100.939C124.73 100.959 124.707 100.978 124.68 100.995C124.652 101.011 124.621 101.025 124.587 101.034C124.513 101.053 124.45 101.059 124.398 101.049C124.347 101.038 124.303 101.016 124.267 100.983C124.231 100.949 124.202 100.907 124.178 100.855C124.156 100.803 124.137 100.746 124.12 100.682L123.981 100.165L124.271 100.087L124.394 100.547C124.401 100.574 124.41 100.602 124.419 100.632C124.429 100.659 124.442 100.684 124.457 100.706C124.474 100.728 124.494 100.744 124.518 100.754C124.543 100.764 124.574 100.764 124.611 100.754C124.648 100.744 124.677 100.73 124.697 100.711C124.716 100.69 124.729 100.667 124.734 100.642C124.741 100.616 124.742 100.588 124.739 100.559C124.735 100.529 124.729 100.499 124.721 100.468L124.595 100.001L124.885 99.9232L125.137 100.862ZM125.09 99.8684L125.369 99.7941L125.403 99.9216L125.407 99.9205C125.411 99.9001 125.419 99.8786 125.431 99.8561C125.443 99.8336 125.458 99.8122 125.478 99.7918C125.497 99.7715 125.521 99.7528 125.548 99.7359C125.575 99.719 125.606 99.7059 125.641 99.6966C125.706 99.679 125.768 99.6771 125.826 99.6907C125.884 99.704 125.934 99.7362 125.976 99.7872C125.993 99.7178 126.022 99.6638 126.063 99.6253C126.103 99.5868 126.159 99.5583 126.228 99.5397C126.291 99.5229 126.347 99.5197 126.395 99.5302C126.445 99.5391 126.487 99.559 126.521 99.5898C126.557 99.619 126.586 99.6573 126.61 99.7048C126.635 99.7506 126.655 99.8019 126.67 99.8586L126.818 100.413L126.529 100.49L126.382 99.9437C126.37 99.8999 126.351 99.8651 126.323 99.8394C126.296 99.812 126.259 99.8047 126.212 99.8174C126.178 99.8264 126.151 99.8397 126.131 99.8575C126.112 99.8737 126.098 99.8933 126.089 99.9164C126.081 99.9391 126.078 99.9643 126.078 99.9917C126.08 100.019 126.085 100.047 126.092 100.075L126.225 100.571L125.935 100.649L125.802 100.152C125.798 100.136 125.792 100.115 125.784 100.091C125.776 100.067 125.765 100.045 125.752 100.025C125.738 100.005 125.72 99.99 125.698 99.9794C125.677 99.9684 125.65 99.9674 125.616 99.9764C125.579 99.9863 125.551 100.002 125.531 100.022C125.512 100.041 125.498 100.064 125.492 100.09C125.486 100.115 125.485 100.143 125.489 100.172C125.492 100.201 125.498 100.231 125.507 100.262L125.632 100.73L125.342 100.807L125.09 99.8684ZM126.659 98.8906L126.949 98.8132L127.116 99.4352L127.119 99.4342C127.141 99.3801 127.175 99.3372 127.222 99.3054C127.269 99.272 127.323 99.2472 127.384 99.2311C127.451 99.2132 127.515 99.2113 127.575 99.2256C127.635 99.2385 127.689 99.2633 127.738 99.3001C127.788 99.3365 127.83 99.3823 127.866 99.4377C127.902 99.4914 127.929 99.5511 127.947 99.6168C127.966 99.6877 127.972 99.7556 127.966 99.8207C127.96 99.8858 127.943 99.9457 127.913 100.001C127.885 100.054 127.845 100.1 127.795 100.14C127.745 100.178 127.685 100.206 127.615 100.225C127.582 100.234 127.549 100.238 127.517 100.237C127.485 100.236 127.454 100.231 127.424 100.224C127.396 100.217 127.37 100.207 127.346 100.195C127.323 100.182 127.304 100.169 127.288 100.155L127.284 100.156L127.317 100.28L127.051 100.351L126.659 98.8906ZM127.191 99.8104C127.21 99.8812 127.246 99.9332 127.297 99.9663C127.35 99.9991 127.414 100.006 127.487 99.986C127.56 99.9664 127.611 99.9294 127.639 99.8749C127.669 99.8201 127.674 99.7573 127.655 99.6865C127.636 99.6157 127.6 99.5639 127.547 99.5311C127.495 99.498 127.433 99.4912 127.36 99.5108C127.286 99.5304 127.235 99.5676 127.205 99.6224C127.177 99.6769 127.172 99.7395 127.191 99.8104ZM129.086 99.6335C129.055 99.7051 129.009 99.7665 128.947 99.8176C128.885 99.8687 128.816 99.9045 128.74 99.9247C128.667 99.944 128.596 99.9507 128.525 99.9447C128.456 99.9384 128.392 99.9203 128.333 99.8905C128.275 99.8591 128.224 99.8168 128.181 99.7635C128.137 99.7102 128.106 99.6462 128.086 99.5715C128.066 99.4968 128.061 99.4256 128.072 99.3578C128.083 99.2901 128.106 99.2287 128.141 99.1739C128.177 99.1173 128.223 99.0691 128.28 99.029C128.338 98.9886 128.403 98.9588 128.475 98.9396C128.542 98.9217 128.606 98.9171 128.666 98.9258C128.728 98.9342 128.783 98.9553 128.832 98.9891C128.882 99.0213 128.926 99.0649 128.963 99.1199C129 99.1749 129.028 99.2398 129.048 99.3145L129.072 99.4053L128.4 99.5849C128.426 99.6371 128.463 99.6749 128.511 99.698C128.558 99.7199 128.61 99.7233 128.667 99.7081C128.715 99.6954 128.752 99.6744 128.779 99.6452C128.806 99.6144 128.828 99.579 128.843 99.539L129.086 99.6335ZM128.73 99.2857C128.718 99.2364 128.691 99.1988 128.648 99.173C128.605 99.1472 128.557 99.1413 128.504 99.1554C128.472 99.164 128.445 99.1767 128.423 99.1936C128.402 99.2104 128.384 99.2296 128.371 99.2512C128.358 99.2711 128.349 99.2934 128.345 99.318C128.341 99.341 128.342 99.3643 128.347 99.3878L128.73 99.2857ZM129.098 98.798L129.388 98.7206L129.429 98.8713L129.433 98.8702C129.448 98.804 129.473 98.7511 129.508 98.7114C129.543 98.6704 129.592 98.6413 129.656 98.6241C129.673 98.6197 129.69 98.6158 129.707 98.6126C129.724 98.6095 129.74 98.6079 129.756 98.608L129.827 98.8726C129.804 98.8717 129.782 98.8727 129.761 98.8756C129.741 98.8769 129.72 98.8805 129.698 98.8864C129.642 98.9011 129.601 98.9206 129.573 98.9446C129.545 98.9687 129.525 98.9973 129.515 99.0304C129.505 99.0619 129.503 99.0977 129.508 99.1377C129.514 99.1777 129.522 99.2209 129.535 99.2673L129.64 99.6594L129.35 99.7368L129.098 98.798Z",
    fill: "#CCCACA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M147.976 118.958L144.967 117.206C144.791 117.125 144.618 117.037 144.45 116.938L97.2034 89.4196L102.35 108.965L157.937 141.343C158.455 141.643 158.929 142.013 159.345 142.442C159.9 141.029 159.989 139.477 159.599 138.01L154.603 119.037C152.572 120.096 149.969 120.119 147.976 118.958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6472 70.1135C95.8089 71.9274 94.9431 74.7594 95.604 77.2694L115.397 152.438C116.437 156.389 120.106 157.193 123.938 156.189L157.319 147.382C161.184 146.369 161.394 140.337 161.394 140.337C162.413 144.204 160.242 148.155 156.571 149.117L121.232 158.372C117.561 159.334 113.724 156.956 112.706 153.089L93.1445 78.7998C92.1557 75.0464 94.1712 71.2149 97.6472 70.1135Z",
    fill: "#829EAF"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.862 77.3343L111.771 84.6379L111.946 85.2373L137.038 77.9336L136.862 77.3343Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M137.663 79.9746L112.573 87.2812L112.748 87.8805L137.839 80.574L137.663 79.9746Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.116 101.47L118.025 108.776L118.201 109.376L143.291 102.069L143.116 101.47Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M143.918 104.113L118.828 111.42L119.003 112.019L144.093 104.713L143.918 104.113Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M177.415 131.709L176.802 131.783L177.05 133.839L177.663 133.765L177.415 131.709Z",
    fill: "#2B478B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.365 29.1817C160.761 32.0458 157.225 33.0699 155.468 31.4325C153.712 29.795 154.396 26.205 156.995 23.3409C159.593 20.4767 163.135 19.4526 164.897 21.0563C166.659 22.66 165.969 26.3175 163.365 29.1817Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.693 40.7114C155.351 39.8561 155.441 39.0233 155.895 38.832C156.35 38.6406 157.018 39.1921 157.338 40.0474C157.657 40.9027 157.59 41.7355 157.136 41.9212C156.681 42.1069 156.036 41.561 155.693 40.7114Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M166.699 54.278H165.374C165.266 54.278 165.178 54.3662 165.178 54.475V54.6156C165.178 54.7244 165.266 54.8126 165.374 54.8126H166.699C166.807 54.8126 166.895 54.7244 166.895 54.6156V54.475C166.895 54.3662 166.807 54.278 166.699 54.278Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.4536 40.3419C76.0564 37.4769 76.7416 33.8533 74.9841 32.2481C73.2266 30.643 69.6918 31.6643 67.089 34.5292C64.4862 37.3941 63.801 41.0178 65.5585 42.6229C67.3161 44.228 70.8508 43.2068 73.4536 40.3419Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.7791 51.8696C65.4367 51.0143 65.5265 50.1815 65.9811 49.9902C66.4357 49.7989 67.1036 50.3504 67.4235 51.2057C67.7434 52.061 67.676 52.8937 67.2214 53.0851C66.7669 53.2764 66.1214 52.7249 65.7791 51.8696Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4252 64.9691H75.1007C74.9922 64.9691 74.9043 65.0573 74.9043 65.1661V65.3067C74.9043 65.4155 74.9922 65.5037 75.1007 65.5037H76.4252C76.5337 65.5037 76.6217 65.4155 76.6217 65.3067V65.1661C76.6217 65.0573 76.5337 64.9691 76.4252 64.9691Z",
    fill: "#2B478B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M139.322 117.609C146.166 111.079 146.325 99.6871 139.678 92.1647C133.03 84.6424 122.093 83.8379 115.249 90.368C108.405 96.898 108.246 108.29 114.894 115.812C121.542 123.335 132.479 124.139 139.322 117.609Z",
    fill: "#3C63C0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.767 96.3463L127.305 107.009L122.893 102.231L120.858 104.437L127.642 111.79L137.143 98.5526L134.767 96.3463Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 156.924,
    y1: 141.012,
    x2: 159.951,
    y2: 134.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 141.972,
    y1: 156.399,
    x2: 143.718,
    y2: 152.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 100.333,
    y1: 144.323,
    x2: 102.078,
    y2: 140.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 119.319,
    y1: 72.8222,
    x2: 122.362,
    y2: 66.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 73.5458,
    y1: 52.5629,
    x2: 76.5855,
    y2: 46.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 65.4123,
    y1: 78.4958,
    x2: 67.1698,
    y2: 74.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 108.364,
    y1: 55.5669,
    x2: 109.841,
    y2: 52.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 56.8173,
    y1: 105.938,
    x2: 59.8423,
    y2: 99.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 123.579,
    y1: 95.839,
    x2: 126.622,
    y2: 89.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 79.0002,
    y1: 125.006,
    x2: 80.7455,
    y2: 121.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 102.559,
    y1: 104.751,
    x2: 96.04,
    y2: 101.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 104.065,
    y1: 85.5857,
    x2: 97.5548,
    y2: 82.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 62.0749,
    y1: 49.1994,
    x2: 63.8424,
    y2: 45.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 107.862,
    y1: 40.6217,
    x2: 109.339,
    y2: 37.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-578.541 92.3167) rotate(174.032) scale(87.9077 88.6374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#C9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#E0EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2857,
    height: 17.6503,
    fill: "white",
    transform: "translate(120.858 95.3121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.fdc3bc15c891c21b991247e69f443855.svg";
export { ForwardRef as ReactComponent };